<template>
  <div
    id="topHeader"
    ref="headerRef"
    class="us-header"
    :class="[{ sticky: stickyStatus, 'is-close': closeCeliing || ceilingList.length === 0 }, `header-${$store.state.locale}`]"
  >
    <SuctionTOP
      v-if="ceilingList.length"
      :class="['suction-top', { 'mobile-suction-top': isMobile }]"
      :component-name="topData.componentName"
      :component-type="topData.componentType"
      :component-title="topData.componentTitle"
      v-bind="topData.componentData"
      @closeCeiling="closeCeliingAction"
    />

    <!-- 第一导航栏 - 共用部分 -->
    <nav v-if="firstNavList.length > 0" class="us-first-nav">
      <div :class="['first-nav-wrap', { 'mobile-first-nav': isMobile }]">
        <a
          v-for="item in firstNavList"
          :key="item.name"
          class="nav-item"
          :class="{ active: (item.url === '/' && $store.state.thinkType === 'online') || (item.url === '/inperson' && $store.state.thinkType === 'inperson') }"
          :title="item.name"
          :target="item.target === '_blank' ? '_blank' : '_self'"
          :href="item.url"
          @click="handleClickNav(item.name, item.url)"
        >
          <img
            v-lazy-load :data-src="item.uploadActiveIcon"
            :data-not-lazy="true"
            alt="hedader-icon"
            :class="['first-nav-icon', {'mobile-first-nav-icon': isMobile}]"
          >
          <span
            class="nav-item-link"
          >
            {{ item.name }}
          </span>
        </a>
      </div>
    </nav>

    <!-- 第二导航栏 - 响应式部分 -->
    <nav class="us-second-nav" :class="{ 'scrolled': isScrolled && !isMobile }">
      <div
        :class="[
          'second-nav-wrap',
          {
            'scrolled': isScrolled && !isMobile,
            'mobile-second-nav': isMobile,
            'bmus-second-nav-wrap': schoolCode === '105',
            'bg-change': showSide
          }
        ]"
      >
        <div class="logo">
          <a :href="siteJumpUrl" :title="$t('common.websiteName')" @click="handleClickNav($t('common.websiteName'), '/')">
            <img
              class="log-img"
              :data-not-lazy="true"
              v-lazy-load :data-src="logoSrc"
              :alt="$t('common.websiteName')"
              :height="logoSize.height"
              :width="logoSize.width"
            >
          </a>
        </div>

        <!-- 桌面端导航 -->
        <div v-if="!isMobile" :class="['second-nav-mid', `second-nav-mid-${$store.state.locale}`]">
          <div
            v-for="item in secondNavList"
            :key="item.onlyID"
            :class="['second-nav-item', {'scrolled': isScrolled && !isMobile}]"
            :title="item.name"
            @click="handleClickNav(item.name)"
          >
            <a
              v-if="item.url"
              class="second-nav-item-link text-overflow-ellipsis"
              :target="item.target === '_blank' ? '_blank' : '_self'"
              :href="item.url"
            >
              {{ item.name }}
            </a>
            <div v-else class="second-nav-item-link text-overflow-ellipsis">
              {{ item.name }}
            </div>
            <div
              v-if="item.children && item.children.length"
              :class="['dropdown-list-wrapper', `dropdown-list-wrapper-${$store.state.locale}`]"
            >
              <ul class="dropdown-list">
                <li v-for="childItem in item.children" :key="childItem.name" class="dropdown-item">
                  <a
                    v-if="childItem.url"
                    class="dropdown-item-link"
                    :href="childItem.url"
                    :target="childItem.target === '_blank' ? '_blank' : '_self'"
                    @click.stop="handleClickNav(childItem.name)"
                  >
                    {{ childItem.name }}
                  </a>
                  <div
                    v-else
                    class="dropdown-item-link hover-color-transition"
                  >
                    {{ childItem.name }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 移动端菜单按钮 -->
        <span
          v-if="isMobile"
          class="iconfont menu-icon"
          :class="showSide ? 'iconcha' : 'iconshouqianniu'"
          @click="showHeaderSettings"
        />

        <!-- 右侧导航 - 共用但样式不同 -->
        <div :class="['second-nav-right', { 'scrolled': isScrolled && !isMobile }]">
          <div v-if="showSchool && !isMobile" class="find-my-school-wrap" :class="{ 'find-my-school-wrap-scrolled': isScrolled }">
            <div class="adress-wrap">
              <span class="iconfont icona-Findmyschool" />
              <span class="find-school">{{ schoolName }}</span>
              <span class="iconfont icon-arrow-bottom-outline" />
              <div :class="['dropdown-list-wrapper', `dropdown-list-wrapper-${$store.state.locale}`]">
                <ul class="dropdown-list">
                  <li
                    v-for="(item, index) in campusNavList"
                    :key="item.name + index"
                    :class="['dropdown-item', {'dropdown-item-compuse': item.distance, 'is-select': item.name === schoolName}]"
                    @click="handleSchoolClick(item)"
                  >
                    <nuxt-link
                      class="dropdown-item-link"
                      :to="item.url"
                    >
                      {{ item.name }}
                      <span v-if="item.distance" class="compuse-distance">{{ item.distance }}KM</span>
                    </nuxt-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-if="isLogin" class="my-courses-content">
            <div class="my-courses-wrap">
              <span class="iconfont icona-Mycourses icona-Mycourses1" />
              <a class="my-courses-text" href="/study#/home/today">My Courses</a>
            </div>
            <!-- 线上火星开启 便于测试 -->
            <div v-if="isHaveHomework" class="homework-icon" @click="goHomework">
              <div class="animation-wrapper">
                <i class="iconfont icon-attend-the-class" />
                <div v-if="isShowHomeworkTip" class="icon-tip" />
              </div>
              <!-- <div class="icon-wrapper">
                <img class="icon" v-lazy-load data-src="~assets/images/icon/icon-homework.svg">
              </div> -->
            </div>
          </div>
          <div v-if="!isLogin" class="login-content">
            <div class="login-wrap" @click="handleLogin">
              <span class="iconfont icona-SignIn" />
              <span class="sign-in-text">{{ langContext.signIn }}</span>
            </div>
          </div>
          <div v-if="isLogin" class="logged-content" :class="{ 'logged-content-scrolled': isScrolled && !isMobile }">
            <div class="logged-in-wrap">
              <div class="user-avatar">
                <img
                  :data-not-lazy="true"
                  v-lazy-load :data-src="`${userInfo.parentAvatar}?im=Resize=(112,112)`"
                  :alt="userInfo.parentNickname"
                  width="26"
                  height="26"
                >
              </div>
              <div class="info-text text-overflow-ellipsis">
                {{ userInfo.parentNickname || $t("common.parent") }}
              </div>
              <span class="iconfont icon-arrow-bottom-outline" />
              <div :class="['dropdown-list-wrapper', `dropdown-list-wrapper-${$store.state.locale}`]">
                <ul class="dropdown-list">
                  <li
                    v-for="(item, index) in userNavigationLinks"
                    :key="item.name + index"
                    class="dropdown-item"
                  >
                    <a
                      v-if="item.target && item.target === '_blank'"
                      class="dropdown-item-link"
                      :href="item.url"
                      target="_blank"
                    >{{ item.name }}</a>
                    <nuxt-link
                      v-else-if="item.url != ''"
                      class="dropdown-item-link"
                      :to="item.url"
                    >
                      {{ item.name }}
                    </nuxt-link>
                  </li>
                  <li class="dropdown-item">
                    <div
                      class="dropdown-item-link"
                      @click="handleLogout()"
                    >
                      {{ langContext.signOut }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            v-if="!isLogin && !isMobile && conversionComponents.length > 0"
            :class="[
              'normal-conversion-component',
              {
                'conversion-component': conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 35
              },
              `conversion-component-${$store.state.locale}`,
            ]"
          >
            <!-- 预约诊断 -->
            <a
              v-if="conversionComponents[0].conversionType === 'link'"
              class="evaluation-btn"
              :href="conversionComponents[0].url"
              :target="conversionComponents[0].target"
            >{{ conversionComponents[0].name }}</a>
            <!-- 分诊台 -->
            <div
              v-if="conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 69"
              class="evaluation-btn"
              @click="handleToFZ(`/triage-desk/${conversionComponents[0].leadComponentId}`)"
            >
              {{ conversionComponents[0].name }}
            </div>
            <!-- 留资组件 -->
            <div
              v-if="conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 35"
              class="evaluation-btn lead-evaluation-btn"
              @click="handleLZ(conversionComponents[0].leadComponentId)"
            >
              {{ conversionComponents[0].name }}
            </div>
          </div>
        </div>

        <!-- 留资组件 -->
        <transition name="slide-down">
          <div
            v-if="showSlideLead"
            ref="leadPostion"
            :class="[
              'lz-position-top',
              `lz-position-top-${$store.state.locale}`,
              {'position-down': showLeadComponent, 'hide-after-animation': !showLeadComponent}
            ]"
          >
            <div v-if="Object.keys(moduleInfo).length === 0" class="placeholder-content">
              <div class="loading-content">
                <div class="loader" />
              </div>
              <div class="bottom-placeholder" />
            </div>
            <transition name="fade">
              <LeadData
                v-if="Object.keys(moduleInfo).length > 0"
                ref="leadDataRef"
                :locale="locale"
                :module-id="moduleInfo.moduleId"
                :component-name="moduleInfo.componentName"
                :component-type="moduleInfo.componentType"
                :component-title="moduleInfo.componentTitle"
                v-bind="moduleInfo.componentData"
                @saveSuccess="handleCloseLead"
              />
            </transition>
            <div class="lz-position-close-btn" @click="handleCloseLead">
              {{ leadBtnText }}
            </div>
          </div>
        </transition>
      </div>
    </nav>

    <!-- 移动端侧边菜单 -->
    <transition name="dropdown">
      <div
        v-if="showSide && isMobile"
        ref="settingPopRef"
        :class="['settings-pop', `settings-pop-${$store.state.locale}`]"
      >
        <div class="menu-actions">
          <!-- <a v-if="!isLogin" class="evaluation-btn menu-btn-item" href="/evaluation">Evaluation Now</a> -->
          <template v-if="!isLogin && conversionComponents.length > 0">
            <!-- 预约诊断 -->
            <a
              v-if="conversionComponents[0].conversionType === 'link'"
              class="evaluation-btn menu-btn-item"
              :href="conversionComponents[0].url"
              :target="conversionComponents[0].target"
            >{{ conversionComponents[0].name }}</a>
            <!-- 分诊台 -->
            <div
              v-if="conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 69"
              class="evaluation-btn menu-btn-item"
              @click="handleToFZ(`/triage-desk/${conversionComponents[0].leadComponentId}`)"
            >
              {{ conversionComponents[0].name }}
            </div>
            <!-- 留资组件 -->
            <div
              v-if="conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 35"
              class="evaluation-btn menu-btn-item"
              @click="handleLZ(conversionComponents[0].leadComponentId)"
            >
              {{ conversionComponents[0].name }}
            </div>
          </template>
          <div v-if="!isLogin" class="login-wrap menu-btn-item" @click="handleLogin">
            <!-- <span class="iconfont icona-blogtubiao-SignIn" /> -->
            <svg t="1752747231008" class="icona-blogtubiao-SignIn" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6912" width="24" height="24"><path d="M411.733333 530.346667c134.826667 0 244.053333-109.226667 244.053334-243.626667S546.133333 42.666667 411.733333 42.666667 167.68 151.893333 167.68 286.293333s109.226667 243.626667 244.053333 243.626667zM21.333333 871.68c0-161.28 130.986667-292.693333 292.266667-292.693333h194.986667c161.28 0 292.266667 130.986667 292.266666 292.693333 0 53.76-43.946667 97.706667-97.28 97.706667H118.613333C64.853333 969.386667 21.333333 925.44 21.333333 871.68zM818.773333 305.92c20.906667 0 37.546667 16.64 37.546667 37.546667v108.8h112.64c18.773333 2.133333 33.706667 17.92 33.706667 37.546666s-14.933333 35.413333-33.706667 37.546667H856.32v108.8c0 20.906667-16.64 37.546667-37.546667 37.546667s-37.546667-16.64-37.546666-37.546667v-108.8h-108.8c-20.906667 0-37.546667-16.64-37.546667-37.546667s16.64-37.546667 37.546667-37.546666h108.8V343.466667c0-20.906667 16.64-37.546667 37.546666-37.546667z" fill="#FFFFFF" p-id="6913" /></svg>
            <span class="sign-in-text">{{ langContext.signIn }}</span>
          </div>
          <div v-if="isLogin" class="my-courses-wrap menu-btn-item">
            <!-- <span class="iconfont icona-Mycourses icona-Mycourses2" /> -->
            <svg id="mx_n_1752809864284" t="1752809864283" class="icona-Mycourses2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7635" width="24" height="24"><path d="M536.32 813.226667s-2.133333-0.426667-5.973333-2.986667c-2.133333-2.56-2.56-4.266667-2.56-5.546667l-6.4-63.573333s0-4.266667 2.56-7.68l328.533333-402.773333c5.546667-6.826667 11.946667-9.813333 21.333333-11.093334h4.693334c6.826667 0 13.226667 2.133333 18.773333 6.826667l34.133333 28.16c7.68 6.4 11.093333 12.8 11.093334 20.48 1.28 10.666667-0.853333 18.346667-6.4 25.173333l-329.386667 404.053334c-2.986667 2.986667-4.693333 3.413333-5.973333 3.413333l-63.146667 6.4h-1.28v-0.853333z" fill="#ffffff" p-id="7636" /><path d="M855.466667 276.906667V113.493333c0-17.066667-6.4-34.133333-20.053334-46.506666-12.373333-12.373333-29.44-20.053333-46.506666-20.053334H147.626667c-37.546667 0-66.986667 29.44-66.986667 66.986667v797.44c0 37.546667 29.44 66.986667 66.986667 66.986667h640.853333c17.066667 0 34.133333-6.4 46.506667-20.053334 12.373333-12.373333 20.053333-29.44 20.053333-46.933333v-354.986667l-227.413333 277.333334c-2.986667 4.693333-9.386667 7.68-15.786667 7.68l-71.68 6.4c-24.746667 1.706667-46.933333-15.36-48.213333-40.533334l-6.4-71.68c0-6.4 1.706667-12.373333 4.693333-15.36l364.373333-442.453333 0.853334-0.853333zM223.146667 202.24h487.253333c18.773333 0 32.853333 15.36 32.853333 32.853333s-15.36 32.853333-32.853333 32.853334H223.146667c-12.373333 0-23.466667-6.4-31.146667-15.36a32.725333 32.725333 0 0 1 0-34.133334c7.68-11.093333 18.773333-17.066667 31.146667-15.36v-0.853333z m199.253333 576H223.146667c-17.066667-1.706667-31.146667-15.36-31.146667-32.853333s14.08-32.853333 31.146667-32.853334H422.4c17.066667 1.706667 31.146667 15.36 31.146667 32.853334 1.706667 17.066667-12.373333 31.146667-31.146667 32.853333z m-232.106667-203.946667c0-18.773333 15.36-32.853333 32.853334-32.853333h132.266666c17.066667 1.706667 31.146667 15.786667 31.146667 32.853333s-14.08 32.853333-31.146667 32.853334h-132.266666c-17.066667 0-32.853333-14.08-32.853334-32.853334z m32.853334-136.96c-12.373333 0-23.466667-6.4-31.146667-15.36a32.725333 32.725333 0 0 1 0-34.133333c6.4-11.093333 18.773333-17.066667 31.146667-15.36h398.506666c12.373333 0 23.466667 6.4 31.146667 15.36 6.4 11.093333 6.4 23.466667 0 34.133333a31.146667 31.146667 0 0 1-31.146667 15.36H223.146667z" fill="#ffffff" p-id="7637" /></svg>
            <a class="my-courses-text" href="/my-courses/list">My Courses</a>
          </div>
          <div v-if="isLogin" :class="['logged-in-wrap menu-btn-item', {'active': showLoggedInDropdown}]" @click="toggleLoggedInDropdown">
            <img
              :data-not-lazy="true"
              v-lazy-load :data-src="`${userInfo.parentAvatar}?im=Resize=(112,112)`"
              :alt="userInfo.parentNickname"
              width="26"
              height="26"
            >
            <div class="info-text text-overflow-ellipsis">
              {{ userInfo.parentNickname || $t("common.parent") }}
            </div>
            <span class="iconfont icon-arrow-bottom-outline" />
          </div>
        </div>
        <!-- 点击登录后的name下拉 -->
        <transition name="dropdown">
          <div v-if="showLoggedInDropdown && isLogin" class="dropdown-list-wrapper footer-dropdown">
            <ul class="dropdown-list">
              <li
                v-for="(item, index) in userNavigationLinks"
                :key="item.name + index"
                class="dropdown-item"
              >
                <a
                  v-if="item.target && item.target === '_blank'"
                  class="dropdown-item-link"
                  :href="item.url"
                  target="_blank"
                >{{ item.name }}</a>
                <nuxt-link
                  v-else-if="item.url != ''"
                  class="dropdown-item-link"
                  :to="item.url"
                >
                  {{ item.name }}
                </nuxt-link>
              </li>
              <li class="dropdown-item">
                <div
                  class="dropdown-item-link"
                  @click="handleLogout()"
                >
                  {{ langContext.signOut }}
                </div>
              </li>
            </ul>
          </div>
        </transition>
        <template v-if="excludeMathGame.length">
          <div
            v-for="item in excludeMathGame"
            :key="item.name + item.onlyID"
            class="second-nav-item"
            :class="{ 'active': activeDropdown === item.onlyID }"
            :title="item.name"
          >
            <div
              class="second-nav-item-header"
              :class="{ 'active': activeDropdown === item.onlyID }"
              @click="toggleDropdown(item.onlyID, $event)"
            >
              <a
                v-if="item.url"
                class="second-nav-item-link hover-color-transition"
                :target="item.target === '_blank' ? '_blank' : '_self'"
                :href="item.url"
              >
                {{ item.name }}
              </a>
              <div v-else class="second-nav-item-link hover-color-transition">
                {{ item.name }}
              </div>
              <span v-if="item.children && item.children.length" class="iconfont icon-arrow-bottom-outline" />
            </div>
            <div
              v-if="item.children && item.children.length"
              class="dropdown-list-wrapper"
              :class="{ 'active': activeDropdown === item.onlyID }"
            >
              <ul class="dropdown-list">
                <li v-for="childItem in item.children" :key="childItem.name" class="dropdown-item">
                  <a
                    v-if="childItem.url"
                    class="dropdown-item-link hover-color-transition"
                    :href="childItem.url"
                    :target="childItem.target === '_blank' ? '_blank' : '_self'"
                    @click.stop="handleClickNav(childItem.name)"
                  >
                    {{ childItem.name }}
                  </a>
                  <div
                    v-else
                    class="dropdown-item-link hover-color-transition"
                  >
                    {{ childItem.name }}
                  </div>
                </li>
              </ul>
            </div>
            <div class="placehoder-box">
              <div class="bottom-line" />
            </div>
          </div>
        </template>
        <div class="footer">
          <div v-if="showSchool" :class="['adress-wrap', {'active': showAdressDropdown}]" @click="toggleAdressDropdown">
            <span class="iconfont icona-Findmyschool" />
            <span class="find-school">{{ schoolName }}</span>
            <span class="iconfont icon-arrow-bottom-outline" />
          </div>
        </div>
        <transition name="dropdown">
          <div v-if="showAdressDropdown" class="dropdown-list-wrapper footer-dropdown find-my-school-dropdown">
            <ul class="dropdown-list">
              <li
                v-for="(item, index) in campusNavList"
                :key="item.name + index"
                :class="['dropdown-item', {'dropdown-item-compuse': item.distance, 'is-select': item.name === schoolName}]"
                @click="handleSchoolClick(item)"
              >
                <nuxt-link
                  class="dropdown-item-link"
                  :to="item.url"
                >
                  {{ item.name }}
                  <span v-if="item.distance" class="compuse-distance">{{ item.distance }}KM</span>
                </nuxt-link>
              </li>
            </ul>
          </div>
        </transition>
      </div>
    </transition>

    <!-- 移动端展示留资 -->
    <transition name="dropdown">
      <div v-if="isMobile && showLeadComponent" ref="leadInfoRef" class="lead-info-box mobile-lead-info-box">
        <div v-if="loadingModules" class="loading-content">
          <div class="loader" />
        </div>
        <div v-if="Object.keys(moduleInfo).length > 0" class="lead-title">
          {{ moduleInfo.componentData.title }}
          <span v-if="showSide" class="iconfont iconcha" @click="closeLead" />
        </div>
        <LeadData
          v-if="Object.keys(moduleInfo).length > 0"
          ref="leadDataRef"
          :locale="locale"
          :module-id="moduleInfo.moduleId"
          :component-name="moduleInfo.componentName"
          :component-type="moduleInfo.componentType"
          :component-title="moduleInfo.componentTitle"
          v-bind="moduleInfo.componentData"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { removeCookies } from 'common/utils';
import { oneApi } from 'config/api';
import bus from 'common/bus';
import mixin from './mixin';
import throttle from 'lodash/throttle';

const SuctionTOP = () => import(/* webpackPrefetch: true */ '@/components/global/DynamicComponents/Ceiling/web')

const LeadData = () => import(/* webpackPrefetch: true */ '../LeadData/web');

export default {
  components: {
    SuctionTOP,
    LeadData,
  },

  mixins: [mixin],
  data() {
    return {
      isScrolled: false,
      lastScrollTop: 0,
      isMobile: false,
      closeCeliing: false,
      showSide: false,
      activeDropdown: null,
      showAdressDropdown: false,
      showLoggedInDropdown: false,
      loadingModules: false,
      moduleInfo: {},
      showLeadComponent: false,
      scrollbarWidth: '',
    };
  },
  computed: {
    topData() {
      if (this.ceilingList.length) {
        const { content } = this.ceilingList[0];
        return JSON.parse(content);
      }
      return {}
    },
    // 计算logo的height和width
    logoSize() {
      if (this.isMobile && this.schoolCode === '105') {
        return {
          height: 26,
          width: 132,
        };
      }
      // 条件1：如果是移动端（isMobile为true），优先用移动端尺寸
      if (this.isMobile) {
        return {
          height: 28,
          width: 194,
        };
      }

      // 条件2：非移动端且未滚动时，根据schoolCode判断
      if (this.schoolCode === '105') {
        return {
          height: 40,
          width: 204,
        };
      }

      // 条件3：非移动端时，先判断是否滚动（isScrolled为true）
      if (this.isScrolled) {
        return {
          height: 23,
          width: 157,
        };
      }

      // 条件4：其他情况（非移动端、未滚动、非105学校）
      return {
        height: 30,
        width: 206,
      };
    },
    leadBtnText() {
      if (this.showLeadComponent) {
        return 'Close';
      }
      return this.conversionComponents.length ? this.conversionComponents[0].name : '';
    },
    showSlideLead() {
      return !this.isLogin && !this.isMobile && this.conversionComponents.length > 0 && this.conversionComponents[0].conversionType === 'lead' && this.conversionComponents[0].conversionComponentType === 35
    },
  },
  watch: {
    showLeadComponent(newVal) {
      // 当showLeadComponent为true时，禁止body滚动
      if (!this.scrollbarWidth) {
        this.scrollbarWidth = this.getScrollbarWidth(); // 获取滚动条宽度
      }
      if (newVal) {
        document.body.style.overflow = 'hidden';
        console.log('ddd', this.scrollbarWidth);
        // 可选：添加padding-right抵消滚动条消失导致的页面抖动
        document.body.style.paddingRight = `${this.scrollbarWidth}px`; // 数值根据实际滚动条宽度调整
      } else {
        // 恢复默认滚动
        document.body.style.overflow = ''; // 清空样式，恢复默认
        document.body.style.paddingRight = '';
      }
    },
    isLogin(newVal) {
      if (newVal === true) {
        if (this.locale === 'hk' || this.locale === 'cn') {
          this.isCheckHaveHomework()
        }
      } else {
        this.isHaveHomework = false;
      }
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
    if (this.schoolCode !== '105') {
      window.addEventListener('scroll', this.handleScroll);
    }

    if (this.isLogin) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showmap, this.error);
      }
      console.log('获取地理位置成功');

      if (this.locale === 'hk' || this.locale === 'cn') {
        console.log('isCheckHaveHomework');
        this.isCheckHaveHomework()
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
    window.removeEventListener('scroll', this.handleScroll);
    // bus.$off('login');
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
    // handleScroll: throttle(function handleScroll() {
    //   if (!this.isMobile) {
    //     const { topHeader } = this.$refs;
    //     if (topHeader) {
    //       const rect = topHeader.getBoundingClientRect();
    //       this.isScrolled = rect.top <= 3;
    //     }
    //   }
    // }, 100),
    // eslint-disable-next-line func-names
    handleScroll: throttle(function () {
      if (!this.isMobile) {
        const { headerRef } = this.$refs;
        if (headerRef) {
          const rect = headerRef.getBoundingClientRect();
          this.isScrolled = rect.top <= 3;
        }
      }
    }, 100),
    handleLogin(obj = {}) {
      const parm = {
        triggerSource: 'header',
        ...obj,
      }
      console.log('parm', parm);
      bus.$emit('login', parm);
    },
    async handleLogout() {
      await this.$axios.post(
        oneApi.commonLogout,
        {},
        { rewritePostBody: true },
      );
      removeCookies('_official_token');
      this.$store.dispatch('ucenter/resetUserInfo');
      this.$store.commit('ucenter/SET_UNPAID_LIST', {});
      this.$store.commit('ucenter/SET_IS_LOGIN', false);
      this.$router.push(this.siteJumpUrl);
    },
    showHeaderSettings() {
      this.showSide = !this.showSide;
      if (this.showSide) {
        this.showOrHideContainer('none');
      } else {
        this.showOrHideContainer('block');
      }
    },
    closeCeliingAction() {
      this.closeCeliing = true;
    },
    showOrHideContainer(displayStyle) {
      this.$nextTick(() => {
        const { settingPopRef } = this.$refs;
        const { headerRef } = this.$refs;
        if (settingPopRef) {
          settingPopRef.style.display = this.showSide ? 'block' : 'none';
        }
        if (headerRef) {
          headerRef.style.minHeight = this.showSide ? '100vh' : '0';
        }
        console.log(`settingPopRef 显示状态: ${this.showSide ? '显示' : '隐藏'}  displayStyle: ${displayStyle}`);
      });
      if (displayStyle) {
        this.$emit('getChildRefs', (refs) => {
          try {
            // 安全访问父组件元素
            if (refs.element1) {
              const targetElement = refs.element1.$el || refs.element1;
              targetElement.style.display = displayStyle;
              console.log(`父组件element1元素已设置为 : ${displayStyle}`);
            }
            if (refs.element2) {
              const targetElement = refs.element2.$el || refs.element2;
              targetElement.style.display = displayStyle;
              console.log(`父组件element2元素已设置为: ${displayStyle}`);
            }
            if (refs.element3) {
              const targetElement = refs.element3.$el || refs.element3;
              targetElement.style.display = displayStyle;
              console.log(`父组件element3元素已设置为: ${displayStyle}`);
            }
          } catch (error) {
            console.error('设置父组件样式时出错:', error);
          }
        });
      }
    },
    toggleDropdown(id, event) {
      if (event.target.tagName === 'A') return;
      if (this.activeDropdown === id) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = id;
      }
    },
    toggleAdressDropdown() {
      this.showAdressDropdown = !this.showAdressDropdown;
      this.showLoggedInDropdown = false;
      if (this.showAdressDropdown) {
        this.$refs.headerRef.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    },
    toggleLoggedInDropdown() {
      this.showLoggedInDropdown = !this.showLoggedInDropdown;
      this.showAdressDropdown = false;
      if (this.showLoggedInDropdown) {
        this.$refs.headerRef.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    },
    handleToFZ(successUrl) {
      if (!this.isLogin) {
        this.handleLogin({ successUrl, triggerSource: 'down' });
      }
    },
    async handleLZ(id) {
      console.log('组件id', id);
      this.showLeadComponent = true;
      if (this.isMobile) {
        this.$nextTick(() => {
          const { settingPopRef } = this.$refs;
          const { leadInfoRef } = this.$refs;
          // const { headerRef } = this.$refs;
          if (settingPopRef) {
            settingPopRef.style.display = 'none';
          }
          if (leadInfoRef) {
            leadInfoRef.style.display = 'block'
            leadInfoRef.style.minHeight = '100vh';
          }
        });
      }
      if (Object.keys(this.moduleInfo).length === 0) {
        await this.queryModuleInfo(id);
      } else {
        this.$refs.leadDataRef && this.$refs.leadDataRef.retsetFormDataList();
      }
    },
    /**
     * 获取留资组件内容
     */
    async queryModuleInfo(id) {
      this.loadingModules = true
      const params = { moduleIdList: [Number(id)] }
      const res = await this.$axios.post(oneApi.queryPageModule, params, { rewritePostBody: true })
      this.loadingModules = false
      if (res.code !== 0) {
        return
      }
      try {
        const moduleList = []
        res.data.moduleList.forEach((item) => {
          if (item.content) {
            const modueleContent = JSON.parse(item.content)
            modueleContent.moduleId = String(item.id)
            const modueleCompData = modueleContent.componentData || {}
            if (item.type === 46 && Array.isArray(modueleCompData.dataList) && !modueleCompData.dataList.length) return
            moduleList.push(modueleContent)
          }
        })
        // eslint-disable-next-line prefer-destructuring
        this.moduleInfo = moduleList[0]
        console.log('moduleList', this.moduleInfo)
      } catch (error) {
        console.log(error)
      }
    },
    handleCloseLead() {
      if (this.showLeadComponent) {
        this.showLeadComponent = false;
        const element = this.$refs.leadDataRef;
        console.log('leadDataRef', element)
        if (element && element.$el) {
          element?.resetFormFields();
          const { height } = element.$el.getBoundingClientRect();
          const leadPostionDom = this.$refs.leadPostion;
          console.log('leadPostionDom', leadPostionDom);
          if (leadPostionDom) {
            // leadPostionDom.style.opacity = '0';
            leadPostionDom.style.top = `-${height}px`;
          }
        }
      } else {
        this.handleLZ(this.conversionComponents[0].leadComponentId);
      }
    },
    // 移动端close
    closeLead() {
      this.showLeadComponent = false;
      this.$nextTick(() => {
        const { settingPopRef } = this.$refs;
        const { leadInfoRef } = this.$refs;
        // const { headerRef } = this.$refs;
        if (settingPopRef) {
          settingPopRef.style.display = 'block';
        }
        if (leadInfoRef) {
          leadInfoRef.style.display = 'none'
          leadInfoRef.style.minHeight = '0';
        }
      });
    },
    async goHomework() {
      // 在用户交互中立即打开新窗口（避免 Safari 阻止）
      const newWindow = window.open('', '_blank');
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        this.$Dialog.alert('弹窗被阻止，请检查浏览器设置！')
        return;
      }

      try {
        await this.getTempToken();
        const url = `${process.env.homeworkUrl}?token=${this.TempToken}&env=${process.env.runtime}&schoolCode=${this.schoolCode}&sourceUrl=${window.location.href}`;
        newWindow.location.href = url
      } catch (error) {
        console.error('Error fetching TempToken:', error);
        newWindow.close();
      }
    },
    getScrollbarWidth() {
      // 创建两个容器，通过宽度差计算滚动条宽度
      const outer = document.createElement('div');
      outer.style.cssText = `
        visibility: hidden;
        width: 100px;
        height: 50px;
        overflow: scroll; /* 让外层容器产生滚动条 */
        position: absolute;
        top: -9999px; /* 隐藏在视口外 */
      `;
      document.body.appendChild(outer);

      // 内层容器用于测量可用宽度
      const inner = document.createElement('div');
      inner.style.width = '100%';
      inner.style.height = '200%'; // 确保外层产生滚动条
      outer.appendChild(inner);

      // 外层总宽度 - 内层可用宽度 = 滚动条宽度
      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

      // 清理DOM
      outer.remove();

      // 兜底处理：如果计算为0，使用常见的15px作为默认值
      return scrollbarWidth || 15;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.us-header {
  position: sticky;
  width: 100%;
  margin-top: 74px;
  top: 0;
  z-index: 1000;

  &.is-close {
    margin-top: 50px; // 这的高度要和first-nav-wrap的高度一样
  }

  &.header-bmus {
    margin-top: 0;
  }

  /* 吸顶组件 */
  .suction-top {
    position: absolute;
    top: -74px;
    width: 100%;

    &.mobile-suction-top {
      top: 0;
      position: relative;
    }
  }

  /* 第一导航栏 */
  .us-first-nav {
    position: absolute;
    top: -50px;
    width: 100%;
    background: #f0f0f0;
    z-index: 1002;

    .first-nav-wrap {
      width: 1252px;
      margin: 0 auto;
      height: 50px;
      display: flex;
      align-items: center;

      &.mobile-first-nav {
        width: 100%;
        height: 15.467vw;
      }
    }

    .nav-item {
      height: 100%;
      width: 225px;
      font-size: 16px;
      font-family: 'Roboto-Flex', sans-serif;
      font-weight: 600;
      color: var(--txt-color-lv4);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .first-nav-icon {
        width: 30px;
        height: 34px;
      }

      &.active {
        background: #e7e7e7;
      }
    }

    .nav-item-link {
      font-family: 'Roboto-Flex', sans-serif;
      margin-left: 17px;
      font-weight: 600;
      color: var(--txt-color-lv4);
    }
  }

  /* 第二导航栏 */
  .us-second-nav {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: #fff;
    width: 100%;
    // border-bottom: 1px solid #FFCC7D;
    transition: all 0.5s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .second-nav-wrap {
      width: 1252px;
      margin: 0 auto;
      height: 64px;
      display: flex;
      align-items: center;
      position: relative;

      &.scrolled {
        height: 52px;

        .logo {
          margin-top: 13px;
        }
      }

      &.bmus-second-nav-wrap {
        height: 81px;

        .logo {
          margin: auto 0;
        }
      }

      &.mobile-second-nav {
        width: 100%;
        padding: 0 6.933vw 0 4.8vw;
        height: 17.067vw;
        justify-content: space-between;
        // border-bottom: 0.533vw solid #f8e8cc;
      }
    }

    .logo {
      flex-shrink: 0;
      margin-top: 13px;
      margin-bottom: auto;  /* 抵消flex居中的默认效果 */
      a {
        display: block;
      }

      .log-img {
        display: block;
        transition: all 0.5s ease;
      }
    }

    .menu-icon {
      font-size: 28px;
      color: #ff9f09;
      cursor: pointer;
    }

    /* 公共下拉菜单 */
    .dropdown-list-wrapper {
      display: none;
      position: absolute;
      left: 50%;
      transform: translateX(-50%) scaleY(0);
      opacity: 0;
      z-index: 99;
      transition: opacity 0.2s ease-out;

      .dropdown-list {
        position: relative;
        background: #fff;
        box-shadow: 0 2px 4px 0 #ffd997;
        border-radius: 0 0 5px 5px;
        z-index: 99;
        list-style: none !important;
        padding: 0;

        .dropdown-item {
          position: relative;
          padding: 0 66px;
          font-size: 16px;
          font-family: 'Roboto-Flex', sans-serif;
          font-weight: 500;
          color: var(--txt-color-lv4);
          text-align: center;
          white-space: nowrap;
          margin-top: 5px;

          &:first-child {
            margin-top: 0;
          }

          &:hover {
            background: #fff5e3;
            color: #ff9f0a;

            .dropdown-item-link {
              color: #ff9f0a;
            }
          }

          &.is-select {
            background: #fff5e3;
            color: #ff9f0a;

            .dropdown-item-link {
              color: #ff9f0a;
            }
          }

          &:last-child {
            &:hover {
              border-radius: 0 0 5px 5px;
            }
          }

          .dropdown-item-link {
            height: 54px;
            line-height: 54px;
            font-size: 16px;
            font-family: 'Roboto-Flex', sans-serif;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-weight: 500;
            color: var(--txt-color-lv4);
          }

          .compuse-distance {
            margin-left: 100px;
          }
        }

        .dropdown-item-compuse {
          .dropdown-item-link {
            justify-content: space-between;
          }
        }
      }
    }

    .dropdown-list-wrapper-bmus {
      .dropdown-list {
        box-shadow: 0 2px 4px 0 #9173ff;

        .dropdown-item {
          position: relative;
          padding: 0 66px;
          font-size: 16px;
          font-family: 'Roboto-Flex', sans-serif;
          font-weight: 500;
          color: var(--txt-color-lv4);
          text-align: center;
          white-space: nowrap;
          margin-top: 5px;

          &:first-child {
            margin-top: 0;
          }

          &:hover {
            background: #f0ecff;
            color: #9173ff;

            .dropdown-item-link {
              color: #9173ff;
            }
          }

          &.is-select {
            background: #f0ecff;
            color: #9173ff;

            .dropdown-item-link {
              color: #9173ff;
            }
          }
        }
      }
    }

    /* 中间导航 - 桌面端 */
    .second-nav-mid {
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      margin-left: 33px;

      &.second-nav-mid-bmus {
        margin-left: 45px;
      }

      &.hidden {
        opacity: 0;
      }
    }

    .second-nav-item {
      position: relative;
      height: 100%;
      margin-left: 11px;
      font-size: 16px;
      font-family: 'Roboto-Flex', sans-serif;
      font-weight: 600;
      color: var(--txt-color-lv4);
      cursor: pointer;
      display: flex;
      align-items: center;

      .second-nav-item-link {
        font-size: 16px;
        font-weight: 600;
        color: var(--txt-color-lv4);
        padding: 9px 15px;
        border-radius: 45px;
      }

      &:first-child {
        margin-left: 0;
      }

      &:hover {
        .second-nav-item-link {
          background: #eee;
        }

        .dropdown-list-wrapper {
          display: block;
          top: 64px;
          transform: translateX(-50%);
          opacity: 1;
          transition: opacity 0.2s ease-in;
        }

        .dropdown-list-wrapper-bmus {
          top: 81px;
        }

        .icon-arrow-bottom-outline {
          transform: rotate(180deg);
          color: #ff9f0a;
        }
      }

      &.scrolled {
        &:hover {
          .dropdown-list-wrapper {
            top: 52px;
          }
        }
      }
    }

    .second-nav-item-bmus {
      margin-left: 8px;
    }

    /* 右侧导航 */
    .second-nav-right {
      display: flex;
      align-items: center;
      height: 100%;

      &.scrolled {
        .adress-wrap {
          .icona-Findmyschool {
            font-size: 20px;
          }
        }

        .login-wrap {
          .icona-SignIn {
            font-size: 20px;
          }
        }

        .my-courses-wrap {
          .icona-Mycourses1 {
            font-size: 20px;
          }
        }
      }

      .find-my-school-wrap {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          .adress-wrap {
            background: #eee;

            .dropdown-list-wrapper {
              display: block;
              top: 50px;
              transform: translateX(-50%);
              opacity: 1;
              transition: opacity 0.2s ease-in;
            }

            .dropdown-list-wrapper-bmus {
              top: 60px;
            }

            .icon-arrow-bottom-outline {
              transform: rotate(180deg);
            }
          }
        }
      }

      .logged-content {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1px;

        &:hover {
          .logged-in-wrap {
            background: #eee;

            .dropdown-list-wrapper {
              display: block;
              top: 50px;
              transform: translateX(-50%);
              opacity: 1;
              transition: opacity 0.2s ease-in;
            }

            .dropdown-list-wrapper-bmus {
              top: 59px;
            }

            .icon-arrow-bottom-outline {
              transform: rotate(180deg);
            }
          }
        }
      }

      .my-courses-content,
      .login-content {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1px;

        &:hover {
          .my-courses-wrap {
            background: #eee;
          }

          .login-wrap {
            background: #eee;
          }
        }
      }

      .homework-icon {
        color: var(--txt-color-link);
        cursor: pointer;

        .animation-wrapper {
          margin-right: 8px;
          position: relative;

          .icon-tip {
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            bottom: 24px;
            left: 22px;
            background: #ff674e;
          }
        }
      }

      .find-my-school-wrap-scrolled:hover {
        .adress-wrap {
          .dropdown-list-wrapper {
            top: 43px;
          }
        }
      }

      .logged-content-scrolled:hover {
        .logged-in-wrap {
          .dropdown-list-wrapper {
            top: 44px;
          }

          .dropdown-list-wrapper-bmus {
            top: 59px;
          }
        }
      }

      .adress-wrap,
      .login-wrap,
      .my-courses-wrap,
      .logged-in-wrap {
        position: relative;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: 'Roboto-Flex', sans-serif;
        font-weight: 600;
        color: var(--txt-color-lv4);
        cursor: pointer;
      }

      .icon-arrow-bottom-outline {
        transition: transform 0.5s ease;
      }

      .adress-wrap {
        padding: 6px 16px;
        border-radius: 45px;

        .icona-Findmyschool {
          font-size: 23px;
        }
      }

      .login-wrap {
        padding: 6px 16px;
        border-radius: 45px;

        .icona-SignIn {
          font-size: 23px;
        }
      }

      .my-courses-wrap {
        padding: 6px 16px;
        border-radius: 45px;

        .icona-Mycourses1 {
          font-size: 23px;
        }
      }

      .logged-in-wrap {
        padding: 6px 16px;
        border-radius: 45px;

        .user-avatar {
          width: 26px;
          height: 26px;
        }
      }

      .my-courses-text {
        margin-left: 7px;
        // flex-shrink: 0;
        text-align: center;
        color: var(--txt-color-lv4);
      }

      .info-text {
        margin: 0 7px;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // flex-shrink: 0;
        text-align: center;
      }

      .find-school {
        margin: 0 7px;
        // flex-shrink: 0;
        text-align: center;
      }

      .sign-in-text {
        margin-left: 7px;
        // flex-shrink: 0;
        text-align: center;
      }

      .normal-conversion-component {
        position: relative;
        width: 172px;
        height: 100%;
        margin-left: 16px;

        .evaluation-btn {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fa6000;
          border: none;
          color: #fff;
          cursor: pointer;
          font-family: Roboto-Flex, sans-serif;
          font-size: 16px;
          font-weight: 700;
          height: 100%;
          line-height: 27px;
          text-align: center;
          width: 172px;
        }
      }

      .conversion-component {
        width: 150px;

        .evaluation-btn {
          width: 150px;
          height: 79px;
          padding: 0 28px;
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
          border-radius: 0 0 15px 15px;
          opacity: 1;
          line-height: 20px;
        }
      }

      .conversion-component-bmus {
        .evaluation-btn {
          background: #8dd430;
        }

        .lead-evaluation-btn {
          height: 96px;
        }
      }
    }
  }

  /* 移动端侧边菜单 */
  .settings-pop {
    width: 100%;
    position: relative;
    background: #fff;
    flex-direction: column;
    z-index: 2000;
    display: none;

    .icon-arrow-bottom-outline {
      transition: transform 0.5s ease;
    }

    .menu-actions {
      width: 100%;
      height: 19.733vw;
      background: #f0f0f0;
      display: flex;
      align-items: center;
      padding: 0 6.933vw;

      .menu-btn-item + .menu-btn-item {
        margin-left: 6.133vw;
      }

      .menu-btn-item {
        // width: 40vw;
        height: 10.4vw;
        border-radius: 13.333vw;
        font-size: 4.267vw;
        font-family: Roboto-Flex;
        font-weight: bold;
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 1 0 auto;

        a {
          color: #fff;
        }
      }

      .evaluation-btn {
        background: #f45d00;
      }

      .login-wrap {
        background: #36b8e0;

        .sign-in-text {
          margin-left: 2.667vw;
        }

        .icona-blogtubiao-SignIn {
          // font-size: 6.4vw;
          width: 6.933vw;
          height: 6.933vw;
        }
      }

      .my-courses-wrap {
        background: #ff9f0a;

        .icona-Mycourses2 {
          font-size: 6.933vw;
        }

        .my-courses-text {
          margin-left: 2.667vw;
        }
      }

      .logged-in-wrap {
        background: #f45d00;

        .user-avatar {
          width: 6.933vw;
          height: 6.933vw;
        }

        .info-text {
          margin: 0 2.667vw;
          width: 18.667vw;
          max-width: 18.667vw;
        }

        &.active {
          .icon-arrow-bottom-outline {
            transform: rotate(180deg);
          }
        }
      }
    }

    .second-nav-item {
      height: 18.667vw;
      display: flex;
      flex-direction: column;
      transition: height 0.3s ease;
      overflow: hidden;
      position: relative;

      .placehoder-box {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 0 6.933vw;
        pointer-events: none; /* 关键属性：让点击事件穿透 */
        .bottom-line {
          width: 100%;
          height: 100%;
          border-bottom: 0.267vw solid #bebebe;
        }
      }

      .second-nav-item-link {
        display: block;
        font-size: 4.267vw;
        font-family: Roboto-Flex;
        font-weight: bold;
        color: #fa9e00;
        flex: 1;
        height: 100%;
        line-height: 18.667vw;
      }

      .icon-arrow-bottom-outline {
        color: #ffa827;
      }

      .second-nav-item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 18.667vw;
        padding: 0 6.933vw;
      }

      .dropdown-list-wrapper {
        max-height: 0;
        overflow: hidden;
      }

      .dropdown-list-wrapper.active {
        max-height: 266.667vw;
      }

      .dropdown-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .dropdown-item {
        margin-bottom: 0.8vw;
        height: 14.133vw;
        padding: 0 6.933vw;
      }

      // .dropdown-item:first-child {
      //   margin-top: 0;
      // }

      .dropdown-item:active {
        background: #fff5e3;
        color: #ff9f0a;

        .dropdown-item-link {
          color: #ff9f0a;
        }
      }

      .dropdown-item-link {
        height: 100%;
        display: block;
        line-height: 14.133vw;
        font-size: 4.267vw;
        font-family: Roboto-Flex;
        font-weight: 500;
        color: var(--txt-color-lv4);
        text-decoration: none;
      }
    }

    .second-nav-item.active {
      height: auto;

      .icon-arrow-bottom-outline {
        transform: rotate(180deg);
      }
    }

    .footer {
      margin-top: 9.333vw;
      display: flex;
      align-items: center;
      padding: 0 6.933vw;

      .adress-wrap {
        padding: 0 2.933vw;
        width: 100%;
        height: 10.133vw;
        border-radius: 1.6vw;
        background: #f5f5f5;
        display: inline-flex;
        align-items: center;
        font-size: 4.267vw;
        font-family: Roboto-Flex;
        font-weight: 600;
        color: var(--txt-color-lv4);

        .icona-Findmyschool {
          font-size: 5.867vw;
          font-weight: 500;
        }

        &.active {
          .icon-arrow-bottom-outline {
            transform: rotate(180deg);
          }
        }
      }

      .find-school {
        margin: 0 3.467vw;
        flex: 1;
      }
    }

    .footer-dropdown {
      margin-top: 1.333vw;
      width: 100%;

      .dropdown-list {
        list-style: none;
        padding: 0;

        .dropdown-item + .dropdown-item {
          margin-top: 1.333vw;
        }

        .dropdown-item {
          padding: 0 6.933vw;

          &.is-select {
            background: #fff5e3;

            .dropdown-item-link,
            .compuse-distance {
              color: #fa9e00;
            }
          }

          &.active {
            background: #fff5e3;
            color: #fa9e00;

            .dropdown-item-link,
            .compuse-distance {
              color: #fa9e00;
            }
          }
        }

        .dropdown-item-link {
          height: 14.4vw;
          line-height: 14.4vw;
          font-size: 4.267vw;
          font-family: Roboto-Flex;
          font-weight: 500;
          color: var(--txt-color-lv4);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }

      .dropdown-item:active {
        background: #fff5e3;
        color: #fa9e00;

        .dropdown-item-link,
        .compuse-distance {
          color: #fa9e00;
        }
      }

      .dropdown-item-compuse {
        width: 100%;

        .compuse-distance {
          color: var(--txt-color-lv4);
        }
      }
    }
  }

  .settings-pop-bmus {
    .menu-actions {
      .menu-btn-item {
        border-radius: 1.333vw;
      }

      .evaluation-btn {
        background: #35d2ff;
      }

      .login-wrap {
        background: #8dd430;
      }

      .my-courses-wrap {
        background: #ffb930;
      }

      .logged-in-wrap {
        background: #8dd430;
      }
    }

    .second-nav-item {
      .second-nav-item-link {
        color: #9173ff;
      }

      .icon-arrow-bottom-outline {
        color: #9173ff;
      }

      .dropdown-item:active {
        background: #f0ecff;
        color: #9173ff;

        .dropdown-item-link {
          color: #9173ff;
        }
      }
    }
  }

  /* 下拉动画 */
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: all 0.3s ease;
    overflow: hidden;
  }

  .dropdown-enter,
  .dropdown-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-10px);
  }

  .dropdown-enter-to,
  .dropdown-leave {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0);
  }

  .slide-down-enter-active,
  .slide-down-leave-active {
    transition: top 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  }

  .slide-down-enter-from,
  .slide-down-leave-to {
    top: -529px;
  }

  .slide-down-enter-to,
  .slide-down-leave-from {
    top: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .lz-position-top {
    position: absolute;
    top: -529px;
    right: -28px;
    z-index: 1001;
    background: #fff;
    transition: top 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);

    .placeholder-content {
      width: 643px;
      height: 529px;
      display: flex;
      flex-direction: column;

      .loading-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .loader {
          width: 50px;
          height: 50px;
          border: 5px solid #f3f3f3;
          border-top: 5px solid #fa6000;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
      }

      .bottom-placeholder {
        margin-top: 23px;
        height: 14px;
        border-radius: 0 0 15px 15px;
      }
    }

    &.position-down {
      top: 0 !important;
      border-radius: 0 0 15px 15px;
      box-shadow: 1px -2px 10px rgba(0, 0, 0, 0.2);

      .placeholder-content {
        .bottom-placeholder {
          background: #fa6000;
        }
      }
    }

    .lz-position-close-btn {
      position: absolute;
      right: 28px;
      width: 150px;
      height: 79px;
      background: #fa6000;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
      border-radius: 0 0 15px 15px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      font-family: 'Roboto-Flex', sans-serif;
      cursor: pointer;
      padding: 0 28px;
    }

    /* 添加延迟隐藏类 */
    &.hide-after-animation {
      animation: hideAfter 0.5s 0.5s forwards;
    }
  }

  .lz-position-top-bmus {
    .placeholder-content {
      .loading-content {
        .loader {
          border-top: 5px solid #8dd430;
        }
      }

      .bottom-placeholder {
        margin-top: 23px;
        height: 14px;
        border-radius: 0 0 15px 15px;
      }
    }

    &.position-down {
      .placeholder-content {
        .bottom-placeholder {
          background: #8dd430;
        }
      }
    }

    .lz-position-close-btn {
      height: 96px;
      background: #8dd430;
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes hideAfter {
    to {
      opacity: 0;
      height: 0;
      padding: 0;
      margin: 0;
      overflow: hidden;
    }
  }
}

@media (min-width: 1280px) and (max-width: 1439px) {
  .us-header {
    width: 100%;
    max-width: 100%;
  }

  .us-header .us-second-nav,
  .us-header .us-first-nav {
    width: 100%;
    max-width: 100%;
  }

  .us-header .us-second-nav .second-nav-wrap,
  .us-header .us-first-nav .first-nav-wrap {
    width: 100%;
    padding-left: 66px;
  }

  .us-header .us-second-nav .bmus-second-nav-wrap {
    width: 1160px;
    max-width: 1160px;
    margin: 0 auto;
    padding: 0;
  }

  .us-header .us-second-nav .second-nav-mid {
    flex: 1;
    margin-left: 12px;
  }

  .us-header .us-second-nav .second-nav-right .logged-content:hover .logged-in-wrap .dropdown-list-wrapper {
    left: auto;
    right: 0;
    transform: translateX(0);
  }
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .us-header {
    width: 100%;
    max-width: 100%;
  }

  .us-header .us-second-nav,
  .us-header .us-first-nav {
    width: 100%;
    max-width: 100%;
  }

  .us-header .us-second-nav .second-nav-wrap,
  .us-header .us-first-nav .first-nav-wrap {
    width: 1264px;
    max-width: 1264px;
  }

  .us-header .us-second-nav .bmus-second-nav-wrap {
    width: 1252px;
    max-width: 1252px;
  }

  .us-header .us-second-nav .second-nav-mid {
    flex: 1;
    margin-left: 33px;
  }

  // .us-header .lz-position-top {
  //   right: 63px;
  // }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .us-header {
    margin-top: 0;

    &.is-close {
      margin-top: 0;
    }

    .us-first-nav {
      position: relative;
      top: auto;

      .first-nav-wrap {
        display: flex;

        .nav-item {
          flex: 1;
          height: 15.467vw;
          font-size: 4.267vw;
          font-family: 'Roboto-Flex', sans-serif;
          font-weight: 600;
          color: var(--txt-color-lv4);
          display: flex;
          align-items: center;
          justify-content: center;

          &.active {
            background: #e7e7e7;
          }

          .first-nav-icon {
            width: 9.333vw;
            height: 10.667vw;
          }
        }

        .nav-item-link {
          margin-left: 4vw;
        }
      }
    }

    .us-second-nav {
      position: relative;

      .menu-icon {
        font-size: 5.867vw;
      }

      .second-nav-right {
        display: none;
      }

      .logo {
        margin: auto 0;
      }

      .logo .log-img {
        width: 51.733vw;
        height: 7.467vw;
      }

      .bmus-second-nav-wrap {
        .logo .log-img {
          width: 35.2vw;
          height: 6.933vw;
        }

        .menu-icon {
          font-size: 7.467vw;
          color: #9173ff;
        }

        .iconcha {
          color: #fff;
        }

        &.bg-change {
          background: #9173ff;
        }
      }
    }

    .us-header .us-second-nav .second-nav-right .logged-content:hover .logged-in-wrap .dropdown-list-wrapper {
      left: auto;
      right: 0;
      transform: translateX(0);
    }

    .lead-info-box {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 3000;
      display: none;
      background: #fff;
      width: 100%;

      .lead-title {
        position: sticky;
        height: 66px;
        background: #fff;
        text-align: center;
        line-height: 66px;
        color: #45454c;
        font-size: 24px;
        font-family: 'Roboto-Flex';

        .iconcha {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 27px;
          display: inline-block;
          font-size: 22px;
          color: #9173ff;
        }
      }

      .loading-content {
        width: 100%;
        height: 100vh;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .loader {
          width: 50px;
          height: 50px;
          border: 5px solid #f3f3f3;
          border-top: 5px solid #9173ff;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
      }

      .lead-components {
        width: 100%;
        height: auto;
        min-height: auto;
        max-height: none;
        border-radius: 0;
        box-shadow: none;
      }
    }

    .lead-info-box ::v-deep(.lead-components .title),
    .lead-info-box ::v-deep(.lead-components .bottom-placeholder) {
      display: none;
    }

    .lead-info-box ::v-deep(.lead-components .content .invisible-lable) {
      padding: 0 26px;
    }
  }
}

// @media (min-width: 769px) {
//   .us-header {
//     position: sticky;
//     top: 0;
//     z-index: 1000;
//     margin-top: 74px;

//     &.is-close {
//       margin-top: 50px;
//     }

//     .suction-top {
//       position: absolute;
//       top: -74px;
//     }

//     .us-first-nav {
//       position: absolute;
//       top: -50px;
//     }
//   }
// }
</style>
